import React from 'react';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import { useStyles } from './styles';

function SecondaryButton({
  cardId,
  questionAnswered,
  answer,
  textButton,
  handleClick,
  leftButton,
  actionButton,
  lightButton,
}) {
  const classes = useStyles(lightButton)();

  return (
    <Button
      fullWidth
      variant="contained"
      className={clsx(
        classes.button,
        leftButton && classes.leftButton,
        questionAnswered &&
          ((questionAnswered && answer === actionButton) ||
            answer === actionButton.answer) &&
          classes.selectedButton,
      )}
      onClick={() =>
        handleClick(
          cardId ? { id: cardId, answer: actionButton } : actionButton,
        )
      }
    >
      {textButton}
    </Button>
  );
}

export default SecondaryButton;
